import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { IntakeSession } from './intake-session';

export const sessionExpiryInterceptor: HttpInterceptorFn = (req, next) => {
  const intakeSession = inject(IntakeSession);
  return next(req).pipe(
    tap({
      error: (error) => {
        if (
          (error.status === 440 || error.status === 401) &&
          error.error?.error === 'Session expired'
        ) {
          intakeSession.clearSession();
        }
      },
    }),
  );
};
